export const leaseRateMappings = {
  dollars_per_month: {
    max: 'q[total_normalized_lease_rate_lteq]',
    min: 'q[total_normalized_lease_rate_gteq]',
    conversion: 1,
    label: 'per month'
  },
  dollars_per_sf_per_month: {
    max: 'q[normalized_lease_rate_lteq]',
    min: 'q[normalized_lease_rate_gteq]',
    conversion: 1,
    label: '/SF/month'
  },
  dollars_per_acre_per_month: {
    max: 'q[normalized_lease_rate_lteq]',
    min: 'q[normalized_lease_rate_gteq]',
    conversion: 1 / 43560,
    label: '/Acre/month'
  },
  dollars_per_year: {
    max: 'q[total_normalized_lease_rate_lteq]',
    min: 'q[total_normalized_lease_rate_gteq]',
    conversion: 1 / 12,
    label: 'per year'
  },
  dollars_per_sf_per_year: {
    max: 'q[normalized_lease_rate_lteq]',
    min: 'q[normalized_lease_rate_gteq]',
    conversion: 1 / 12,
    label: '/SF/year'
  },
  dollars_per_acre_per_year: {
    max: 'q[normalized_lease_rate_lteq]',
    min: 'q[normalized_lease_rate_gteq]',
    conversion: 1 / (43560 * 12),
    label: '/Acre/year'
  }
};

export const excludedColumns = [
  'buyerName',
  'investmentType',
  'landlordString',
  'ownerEmail',
  'ownerName',
  'ownerPhoneNumber',
  'sellerName',
  'databaseName',
  'tenantContactString',
  'tenantString'
];

export const columnTypes = {
  name: 'alpha',
  suite: 'alpha',
  buildingSizeLabel: 'amount',
  buyerName: 'alpha',
  dealStatusLabel: 'alpha',
  leaseDate: 'amount',
  leaseExecutionDate: 'amount',
  leaseExpirationDate: 'amount',
  leaseRateLabel: 'amount',
  lotSize: 'amount',
  numberOfUnits: 'amount',
  price: 'amount',
  propertyType: 'alpha',
  propertySubtype: 'alpha',
  saleDate: 'amount',
  sellerName: 'alpha',
  sizeLabel: 'amount',
  tenantString: 'alpha',
  createdAt: 'amount',
  createdBy: 'alpha',
  lastUpdatedAt: 'amount',
  lastUpdatedBy: 'alpha'
};
